<template>
  <div :class="selected ? 'list-item selected' : 'list-item'">
    <slot></slot>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  components: {},
  props: ["selected"],
};
</script>
<style scoped>
.list-item {
  border-radius: 8px;
  background-color: var(--backgroundColor);
  padding: 5px 20px;
  cursor: pointer;
}

.list-item:hover {
  filter: drop-shadow(0px 2px 3px var(--shadow));
}

.selected {
  color: var(--backgroundColor);
  background-color: var(--contrastColor);
}
</style>
